module.exports = __webpack_public_path__ + "assets/img/WelcomeVideo-pg.63f925a0.png";